import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'semantic-ui-css/semantic.min.css'
import './App.css';


// Sadece hata takibi: performans/trace, replay ve log gonderimi yok.
Sentry.init({
  dsn: 'https://S1MZhZeWG6tgq8gMqxfW7WWG@s2579936.eu-central-1a.betterstackdata.com/2744883',
  enabled: process.env.NODE_ENV === 'production',
  tracesSampleRate: 0,
});

ReactDOM.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
